import React from 'react'
import { motion } from 'framer-motion'
import BackgroundImage from '../../../components/BackgroundImage'
import Check from 'images/inline/spot-the-diff/check.svg'
import Error from 'images/inline/spot-the-diff/error.svg'
import withStyles from '@mui/styles/withStyles';
import CircularProgress from '@mui/material/CircularProgress'

export const StackedImage = ({
  image,
  backgroundImage,
  style,
  className,
  isDropped,
  onClick,
  gameFinished,
  isReplacing,
  isWrongAnswer,
  isCorrectAnswer,
  isComingFromBottom,
  cursorStyle,
  checkingMatches = true,
  draggableCard,
  gameType,
}) => {
  // Animation for the background image (slot), moving it to the top-left and shrinking
  const stackEffect = {
    dropped: {
      top: 10,
      left: 10, // Moves to top-left corner
      useLayoutEffect: 0,
      transition: {
        type: 'inertia',
        damping: 30,
        duration: 3,
      },
    },
    initial: {
      scale: 1,
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
    },
  }

  // Animation for the dropped card, moving it to the bottom-right
  const dropEffect = {
    dropped: {
      bottom: 4, // Moves to top-left corner
      right: 4,
      transition: {
        type: 'spring',
        damping: 20,
        duration: 3,
      },
    },
  }

  const iconStyle = {
    display: 'flex',
    width: '24px',
    height: '24px',
    background: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    position: 'absolute',
    zIndex: 3,
    transition: 'all 0.3s',
    top: '29%',
    left: '57%',
  }

  const SpinnerAdornment = withStyles({
    spinner: {
      color: 'purple', // Add your custom styles here
    },
  })(props => <CircularProgress className={props.classes.spinner} size={20} />)

  return backgroundImage ? (
    <div
      style={{
        position: 'relative', // Enables absolute positioning of children
        cursor: cursorStyle,
        ...style,
      }}
      className={className}
    >
      {/* Background Image Animation */}
      <motion.div
        style={{
          position: 'absolute',
          width: '65%',
          height: '65%',
          zIndex: 1, // Below the dropped card
        }}
        initial="initial"
        animate={isDropped ? 'dropped' : 'initial'}
        variants={stackEffect}
      >
        <BackgroundImage
          isDropped={isDropped}
          style={{ width: '100%', height: '100%' }}
          image={backgroundImage}
          gameType={gameType}
        />
      </motion.div>

      {/* Dropped Card Animation */}

      <motion.div
        style={{
          position: 'absolute',
          width: '65%', // The dropped card takes 50% of the slot's size
          height: '65%',
          zIndex: 2, // On top of the background
        }}
        initial="initial"
        animate={isDropped ? 'dropped' : 'initial'}
        variants={dropEffect}
      >
        {draggableCard}
      </motion.div>
      {(isWrongAnswer || (isComingFromBottom && isReplacing)) && (
        <div style={{ ...iconStyle, backgroundColor: 'red' }}>
          <Error />
        </div>
      )}
      {isCorrectAnswer && (
        <div style={{ ...iconStyle, backgroundColor: 'green' }}>
          <Check />
        </div>
      )}
      {checkingMatches && (
        <div
          style={{
            ...iconStyle,
            backgroundColor: 'white',
            padding: '4px',
            width: 'unset',
            height: 'unset',
          }}
        >
          <SpinnerAdornment />
        </div>
      )}
    </div>
  ) : (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        ...style,
      }}
      className={className}
    >
      <BackgroundImage
        gameType={gameType}
        isReplacing={isDropped}
        image={image}
        onClick={onClick}
        cancelHover={gameFinished}
        isDropped={isDropped}
        isWrongAnswer={isWrongAnswer}
        isCorrectAnswer={isCorrectAnswer}
        isReplacingBottom={isReplacing && isComingFromBottom}
      />
    </div>
  )
}
